<template>
  <div class="invoice_container">
    <div class="breadcrumbs ellipsis">
      <Tooltip v-if="dataSet.goodsCode">
        <span v-html="$t('query.result.rules.breadcrumbs', {from: dataSet.exporter, to: dataSet.importer, product: `${_.truncate(dataSet.goodsName, {length: 5})} (${dataSet.goodsCode || ''})`})"></span>
        <div slot="content" style="text-align:center;font-size:13px;white-space:normal;line-height: 20px;">
          <p v-html="$t('query.result.rules.breadcrumbs', {from: dataSet.exporter, to: dataSet.importer, product: `${dataSet.goodsName} (${dataSet.goodsCode})`})"></p>
        </div>
      </Tooltip>
      <div class="product_meta">
        <span class="invoice">发票号：{{dataSet.invoiceCode}}</span>
        <span class="pn">成品料号：{{dataSet.goodsPN}}</span>
        <a href="#" @click.prevent="isShowMaterials=!isShowMaterials" :class="{line2: true, materials: true, active: isShowMaterials}">原材料</a>
      </div>
      <div class="btns">
        <Button type="primary" class="btn save" :loading="isSaving" @click.prevent="saveHandle" :disabled="isCooing || (dataSet.id && (!dataSet.ftas || dataSet.ftas.length === 0))"><span>保存</span></Button>
        <Button type="primary" class="btn coo" :loading="isCooing" @click.prevent="cooHandle" :disabled="isSaving || (dataSet.id && (!dataSet.ftas || dataSet.ftas.length === 0))"><span>判定</span></Button>
      </div>
    </div>
    <transition name="slide-fade">
      <div class="material_list" v-show="isShowMaterials">
        <Table :columns="query.columns" :data="dataSet.materials" :height="dataSet.materials && dataSet.materials.length > 6 ? 300 : '-'" no-data-text="暂无记录"></Table>
      </div>
    </transition>
    <div class="ftas" v-if="dataSet.ftas && dataSet.ftas.length > 0">
      <div class="fta" v-for="(item, index) in dataSet.ftas" :key="`fta-${item.ftaId}-${index}`">
        <Tabs>
          <TabPane :label="item.ftaName">
            <PanelContent :dataSet="item" :cooErrData="cooErrData" :isSelectWo.sync="isSelectWo" :isSelectCraft.sync="isSelectCraft" />
          </TabPane>
        </Tabs>
      </div>
    </div>
    <div class="empty_ftas" v-else-if="dataSet && dataSet.id">
      <img src="~@/assets/images/coo/nocoo.png">
      <div class="desc">暂无符合条件的FTA哦~</div>
    </div>
    <DoingModal :isShow="isShowDoingModal" :index="doingStep"></DoingModal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import PanelContent from './VoteContentPanel'
import DoingModal from './doingModal'
const { mapState: mapDataState, mapGetters: mapDataGetters } = createNamespacedHelpers('data')

export default {
  name: 'VoteContent',
  components: { PanelContent, DoingModal },
  props: {
    dataSet: {
      type: Object,
      default: () => { return {} },
      required: false
    }
  },
  data () {
    return {
      isShowMaterials: false,
      isSaving: false,
      isCooing: false,
      isShowDoingModal: false,
      doingStep: 0,
      doingTimer: null,
      query: {
        columns: [
          {title: '原材料料号', key: 'materialPN', align: 'center', width: 120},
          {
            title: '原材料商品编码',
            key: 'materialCode',
            align: 'center',
            ellipsis: true,
            width: 200,
            render: (h, params) => {
              return h('span', {
                attrs: {title: params.row.materialCode}
              }, params.row.materialCode)
            }
          },
          {
            title: '原材料名称',
            key: 'materialName',
            align: 'center',
            ellipsis: true,
            width: 200,
            render: (h, params) => {
              return h('span', {
                attrs: {title: params.row.materialName}
              }, params.row.materialName)
            }
          },
          {
            title: '原材料单价',
            key: 'materialPrice',
            align: 'center',
            render: (h, params) => {
              return h('span', this.$options.filters.amountThousands(params.row.materialPrice || 0) || '-')
            }
          },
          {title: '原材料单位', key: 'materialUnit', align: 'center', width: 110},
          {title: '原材料原产地', key: 'materialOrigin', align: 'center'},
          {
            title: '原材料备注',
            key: 'materialDescription',
            align: 'center',
            ellipsis: true,
            render: (h, params) => {
              return h('span', {
                attrs: {title: params.row.materialDescription || '-'}
              }, params.row.materialDescription || '-')
            }
          }
        ]
      },
      isWo: null,
      isSpecial: null,
      cooErrData: []
    }
  },
  computed: {
    isSelectWo: {
      get () {
        if (this.isWo === null) {
          // return !!this.dataSet.ftas[0].wo
          // return this.dataSet.wo === 'Y'
          return !!this.dataSet.wo
        } else {
          return this.isWo
        }
      },
      set (v) {
        this.isWo = v
      }
    },
    isSelectCraft: {
      get () {
        if (this.isSpecial === null) {
          // return !!this.dataSet.ftas[0].specialCraft
          // return this.dataSet.specialCraft === 'Y'
          return !!this.dataSet.specialCraft
        } else {
          return this.isSpecial
        }
      },
      set (v) {
        this.isSpecial = v
      }
    },
    apiPrice () {
      if (this._.isEmpty(this.apiValue)) {
        return null
      } else {
        return this.getApiValue()
      }
    },
    ...mapDataState({
      apiValue: state => state.apiValue
    })
  },
  methods: {
    saveHandle () {
      if (this.$parent.isShowLoader) return
      this.$Loading.start()
      this._h.scrollTop()
      this.$parent.isShowLoader = true
      this.cooErrData = []
      this.$api.coo.determination.save(this.dataSet.id, {wo: this.isSelectWo ? 1 : 0, specialCraft: this.isSelectCraft ? 1 : 0}, {
        success: response => {
          this.$Loading.finish()
          if (response.data.code === 200) {
            this.$Message.success({content: '保存成功！', closable: true})
          } else {
            this.$Message.warning({content: this.$t('common.codeError'), closable: true})
          }
          this.$parent.isShowLoader = false
        },
        error: (errorMsg) => {
          this.$parent.isShowLoader = false
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    },
    cooHandle () {
      if (this.$parent.isShowLoader) return
      this.cooErrData = []
      this.GJFNotice(status => {
        if (status) {
          let jf = this.getApiValue()(6)
          if (jf && jf.integral && jf.integral > 0) {
            this.GConfirm(`本次查询将消耗${jf.integral}积点，当天重复查询不再扣除积点。`, status => {
              if (status) {
                this.doCoo()
              }
            })
          } else {
            this.doCoo()
          }
        } else {
          this.doCoo()
        }
      })
    },
    doCoo () {
      this.$Loading.start()
      this._h.scrollTop()
      this.$parent.isShowLoader = true
      // this.$Message.loading({content: '判定中', duration: 0})
      this.doingStep = 0
      this.isShowDoingModal = true
      this.doingTimer = setTimeout(() => {
        this.doingStep = 1
        this.doingTimer = setTimeout(() => {
          this.doingStep = 2
        }, this._.random(1000, 2000))
      }, this._.random(200, 800))
      this.$api.coo.determination.submit(this.dataSet.id, {wo: this.isSelectWo ? 1 : 0, specialCraft: this.isSelectCraft ? 1 : 0}, {
        success: response => {
          this.setDoingState(() => {
            this.$Loading.finish()
            this.$Message.destroy()
            if (response.data.code === 200) {
              if (response.data.data.status === 1) {
                this.$Message.success({content: '判定成功！', closable: false, duration: 2})
                setTimeout(() => {
                  this.$router.push({ name: 'RulesDecideVoteResult', params: { id: response.data.data.id } })
                }, 2000)
              } else {
                this.$Message.warning({content: '判定失败！', closable: true})
                this.cooErrData = response.data.data.ftas
              }
            } else {
              this.$Message.warning({content: this.$t('common.codeError'), closable: true})
            }
            this.$parent.isShowLoader = false
          })
        },
        error: errorMsg => {
          this.setDoingState(() => {
            this.$parent.isShowLoader = false
            this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
            this.$Loading.error()
          })
        }
      })
    },
    setDoingState (callback) {
      if (this.doingTimer !== null) {
        clearTimeout(this.doingTimer)
        if (this.doingStep === 0) {
          this.doingStep = 1
          setTimeout(() => {
            this.doingStep = 2
            setTimeout(() => {
              this.doingStep = 3
              setTimeout(() => {
                this.isShowDoingModal = false
                callback && callback()
              }, 800)
            }, this._.random(1000, 1500))
          }, this._.random(200, 800))
        } else if (this.doingStep === 1) {
          this.doingStep = 2
          setTimeout(() => {
            this.doingStep = 3
            setTimeout(() => {
              this.isShowDoingModal = false
              callback && callback()
            }, 800)
          }, this._.random(1000, 2500))
        } else if (this.doingStep === 2) {
          this.doingStep = 3
          setTimeout(() => {
            this.isShowDoingModal = false
            callback && callback()
          }, 800)
        }
      }
    },
    ...mapDataGetters([
      'getApiValue'
    ])
  }
}
</script>
<style scoped>
  .invoice_container{}
  .breadcrumbs{
    /*font-size: 12px;*/
    font-size: 14px;
    color: #333;
    width: 90%;
    margin: 5px 0 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .breadcrumbs >>> .ivu-tooltip span span{
    /*color: #1F8AFD;*/
    color: #151515;
    font-weight: bold;
    cursor: default;
  }
  .product_meta .pn{
    padding: 0 15px;
  }
  .product_meta .materials{
    background: url("~@/assets/images/coo/icon_hs.png") no-repeat right center transparent;
    background-size: 7px auto;
    padding-right: 12px;
  }
  .product_meta .materials.active{
    background-image: url("~@/assets/images/coo/icon_xl.png");
    background-size: 8px;
  }
  .material_list{
    margin: 30px 0 20px;
  }
  .slide-fade-enter-active {
    transition: all .2s ease;
  }
  .slide-fade-leave-active {
    transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translateY(-50px);
    opacity: 0;
  }
  .material_list >>> .ivu-table-wrapper{
    border: 0 none;
  }
  .material_list >>> .ivu-table{
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(196,196,196,0.50);
  }
  .material_list >>> .ivu-table th{
    background-color: rgba(31, 138, 252, 0.05);
    border-bottom: 0 none;
  }
  .material_list >>> .ivu-table td{
    border-color: #f1f1f1;
  }
  .fta{
    position: relative;
  }
  .fta >>> .ivu-tabs-bar{
    border-bottom: 0 none;
    margin-bottom: 0;
  }
  .fta >>> .ivu-tabs-nav{
    border-color: #eee;
  }
  .fta >>> .ivu-tabs-tabbar{
    background-color: #2681FF;
  }
  .fta >>> .ivu-tabs-ink-bar{
    height: 1px;
    background-color: #1F8AFD;
  }
  .fta >>> .ivu-tabs-tabpane{
    /*padding: 0 2px;*/
    background-color: #fff;
    padding: 20px 18px 25px;
    -webkit-box-shadow: 0 2px 4px 0 rgba(223, 223, 223, .50);
    box-shadow: 0 2px 4px 0 rgba(223, 223, 223, .50);
    margin-bottom: 18px;
  }
  .ftas .fta:last-child >>> .ivu-tabs-tabpane{
    margin-bottom: 5px;
  }
  .empty_ftas{
    padding-top: 20px;
  }
  .empty_ftas img{
    display: block;
    width: 220px;
    margin: 0 auto;
  }
  .empty_ftas .desc{
    text-align: center;
    font-size: 14px;
    color: 14px;
    margin-top: 20px;
  }
  .fta >>> .ivu-tabs-tab{
    /*font-size: 1.2rem;*/
    font-size: 1.4rem;
    color: #999;
  }
  /*.fta >>> .ivu-tabs-nav .ivu-tabs-tab:nth-of-type(2){*/
  /*padding-right: 0;*/
  /*position: relative;*/
  /*left: -14px;*/
  /*}*/
  .fta >>> .ivu-tabs-tab-active{
    color:  #1F8AFD;
  }
  .btn{
    width: 100px;
    border: 1px solid #1F8AFD;
    border-radius: 3px;
    height: 32px;
    /*line-height: 32px;*/
    float: left;
    /*font-size: 12px;*/
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
  }
  .btn span{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .btn.coo{
    background-color: #1F8AFD;
    color: #fff;
  }
  .btn.ivu-btn-loading{
    cursor: default;
  }
  .btn.ivu-btn-loading span{
    position: static;
    transform: none;
  }
  .btn.save{
    background-color: #fff;
    color: #1F8AFD;
    margin-right: 15px;
  }
  .btn.save[disabled],
  .btn.coo[disabled]{
    color: #bbbec4;
    /*background-color: #f7f7f7;*/
    border-color: #dddee1;
    cursor: default;
  }
  .btn.coo[disabled]{
    background-color: #fff;
    color: #bbbec4;
  }
</style>



// WEBPACK FOOTER //
// src/components/RulesDecide/zh-CN/VoteContent.vue